import TenantSettingsManager from '../singleton/tenant-settings-manager';

export const DateFormat = {
  get DateTime(): string {
    const settings = TenantSettingsManager.getInstance().getSettings();
    return `${settings.dateFormat} ${settings.timeFormat}`;
  },
  get Date(): string {
    return TenantSettingsManager.getInstance().getSettings().dateFormat;
  },
  get Time(): string {
    return TenantSettingsManager.getInstance().getSettings().timeFormat;
  },
};

export const getSystemTimezone = (): string =>
  TenantSettingsManager.getInstance().getSettings().timezone;

export type DateFormatEnumType = (typeof DateFormat)[keyof typeof DateFormat];

export enum TimeOfDayPrefenceEnum {
  START = 'START',
  END = 'END',
  CURRENT = 'CURRENT',
}
